module.exports = __webpack_public_path__ + "static/media/S5P2_reproductive-implications.35da62c6.mp3";